export default __webpack_public_path__ + "static/media/img (5).adbeadb7.jpg";